import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeToYoutube}
            sections={<PairTransferGuideContent sourceKey="youtube" destKey="youtube" />}
        />
    );
}
